module.exports = __webpack_public_path__ + "media/images/common-nav/national-forests/pisgah_national_forest-ab608d35a7535d54f926fa4c6b558985.jpg";